var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03f---Security-ID---Error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-158.000000, -424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(160.000000, 426.000000)",
    fill: "#D82028"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,58 C11.4314575,58 -2,44.5685425 -2,28 C-2,11.4314575 11.4314575,-2 28,-2 C44.5685425,-2 58,11.4314575 58,28 C58,44.5685425 44.5685425,58 28,58 Z M28,54 C42.3594035,54 54,42.3594035 54,28 C54,13.6405965 42.3594035,2 28,2 C13.6405965,2 2,13.6405965 2,28 C2,42.3594035 13.6405965,54 28,54 Z",
    id: "Oval-3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,13.5 C26,12.3954305 26.8954305,11.5 28,11.5 C29.1045695,11.5 30,12.3954305 30,13.5 L30,31.5 C30,32.6045695 29.1045695,33.5 28,33.5 C26.8954305,33.5 26,32.6045695 26,31.5 L26,13.5 Z",
    id: "Line-2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    cx: 28,
    cy: 41,
    r: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.069e1c1a144261c526db59f164e6c3dc.svg";
export { ForwardRef as ReactComponent };